export default __webpack_public_path__ + "static/media/home-hover.7ff82b01.svg";